<template>
	<div>
		<v-data-table
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:loading="loading"
			dense
			:height="pageHeight(174)"
			single-expand
			:headers="headers"
			fixed-header
			item-key="officeName"
			class="medical-staff-data-table"
			:items="groupedNotes"
			:footer-props="getDataTableFooterProps('medicalNotesCategoryTable')"
			:items-per-page="-1"
			 :server-items-length="mappedItems.length">
			<template #item="{ item, index, expand, isExpanded }">
				<tr @click="expand(!isExpanded)" :class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]">
					<td class="text-left">
						<v-btn small icon>
							<v-icon small color="primary">
								{{ isExpanded ? 'mdi-arrow-down-drop-circle' : 'mdi-arrow-right-drop-circle' }}
							</v-icon>
						</v-btn>
						<span class="font-weight-bold font-size12">
							{{ item.officeName }}
						</span>
					</td>
				</tr>
			</template>
			<template #expanded-item="{ item }">
				<tr style="cursor: default; background-color: #fff !important">
					<td class="pa-3">
						<v-data-table
							:items="item.notes"
							:headers="insideHeaders"
							dense
							:items-per-page="-1"
							hide-default-footer
							class="data-table-outline"
							:height="pageHeight(95)"
							fixed-header>
							<template #item="{ item, index }">
								<tr :class="getRowsForDataTable(index)" class="font-weight-medium font-size12-5">
									<td class="text-left">{{ item.medicalNoteCategoryName }}</td>
									<td class="text-left clip-text">
										{{ item.medicalNoteCategoryDescription }}
									</td>
									<td class="text-left">{{ item.officeName }}</td>
									<td class="text-left">
										{{ formatBillingTime(item.billingSecondsForThisMedicalNoteCategory) }}
									</td>
									<td class="text-right">
										<v-icon small class="mr-2 pl-4" :style="item.status === 1 ? 'color: #09CB09' : ''">
											mdi-checkbox-blank-circle
										</v-icon>
									</td>
									<td class="text-left">
										<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
											<template #activator="{ on, attrs }">
												<v-icon class="mr-1 float-right" color="black" v-bind="attrs" v-on="on">
													mdi-dots-horizontal
												</v-icon>
											</template>
											<v-list class="px-0" dense>
												<v-list-item class="py-0 my-0" link dense @click="synchronizeDrawers(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="black">mdi-pencil</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold font-size14">{{ $t('edit') }}</v-list-item-content>
												</v-list-item>
												<v-divider />
												<v-list-item link dense @click="handleToggleStatus(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="black">mdi-refresh</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold font-size14">
														{{ $t('change') }} {{ $t('status') }}
													</v-list-item-content>
												</v-list-item>
												<v-list-item link dense @click="openDialog(item)">
													<v-list-item-icon class="mx-1">
														<v-icon color="red">mdi-trash-can-outline</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold font-size14">{{ $t('delete') }}</v-list-item-content>
												</v-list-item>
											</v-list>
										</v-menu>
									</td>
								</tr>
							</template>
						</v-data-table>
					</td>
				</tr>
			</template>
		</v-data-table>

		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteMedicalNoteCategoryTemplate();
			" />
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
	getDataTableFooterProps,
	getRowsForDataTable,
	toggleHeaders,
	showErrorAlert,
	showSuccessAlert,
} from '@/utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	components: {
		DeleteDialog,
	},
	data () {
		return {
			showDeleteDialog: false,
			selectedItemId: null,
			loading: true,
			mappedItems: [],
		};
	},
	async mounted () {
		this.loading = true;
		await this.$store.dispatch('filterbar/AppBarUserStatusVerifier', 1).then((res) => {
			this.getMedicalNoteTemplate();
		});
		if (this.roleName === 'ORGANIZATION_ADMIN') {
			this.toggleHeaders();
		}
		this.loading = false;
	},
	methods: {
		toggleHeaders,
		openDialog (item) {
			this.showDeleteDialog = true;
			this.selectedItemId = item.id;
		},
		getRowsForDataTable,
		getDataTableFooterProps,
		async getMedicalNoteTemplate () {
			await this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplate').then((res) => {
				this.toggleHeaders();
			});
		},
		handleToggleStatus (item) {
			const body = {
				id: item.id,
				status: item.status === 0 ? (item.status = 1) : (item.status = 0),
			};
			this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplatechangestatus', body).then((res) => {
				this.getMedicalNoteTemplate();
			});
		},
		formatBillingTime (seconds) {
			const minutes = Math.floor(seconds / 60);
			const remainingSeconds = seconds % 60;
			if (this.$i18n.locale === 'en') {
				return `${minutes}m ${remainingSeconds}s`;
			} else {
				return `${minutes} minutos ${remainingSeconds}segundos`;
			}
		},
		synchronizeDrawers (item) {
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: item,
				page2: 'medical notes',
				item: item,
			});
		},
		deleteMedicalNoteCategoryTemplate () {
			this.loading = true;
			this.$store
				.dispatch('medicalnotecategory/deletemedicalnotecategorytemplate', this.localSelectedItemId)
				.then(() => {
					showSuccessAlert(this.$t('success-operation'));
					this.localDialog = false;
					this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplate');
				})
				.catch((error) => {
					if (error.message === '403 Forbidden Error') {
						showErrorAlert(this.$t('not-authorized-to-delete-medical-note'));
					} else {
						showErrorAlert(this.$t('not-authorized-to-delete-medical-note'));
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
	computed: {
		...mapState({
			medicalNotesCategories: (state) => state.medicalnotecategory.medicalNotesCategories,
		}),
		...mapGetters({
			roleName: 'authentication/getRole',
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
			appBarUserStatusVerifier: 'filterbar/getUserStatusVerifier',
		}),
		headers () {
			return [
				{
					text: this.$t('facility-name'),
					value: 'officeName',
					sortable: true,
					class: 'secondary',
					align: 'start',
				},
			];
		},
		insideHeaders () {
			return [
				{
					text: this.$t('category'),
					value: 'medicalNoteCategoryName',
					sortable: true,
					class: 'secondary',
					align: 'start',
				},
				{
					text: this.$t('description'),
					value: 'medicalNoteCategoryDescription',
					sortable: false,
					class: 'secondary',
					align: 'start',
				},
				{ text: this.$t('location-name'), value: 'officeName', sortable: false, class: 'secondary', align: 'start' },
				{ text: this.$t('billings'), sortable: false, class: 'secondary', align: 'start' },
				{ text: this.$t('actions'), sortable: false, class: 'secondary', align: 'center' },
				{ text: this.$t('status'), sortable: false, class: 'secondary', align: 'end' },
			];
		},
		endHeader () {
			return [];
		},
		filteredNotes () {
			const searchTerm = this.appBarSearch ? this.appBarSearch.toLowerCase() : '';
			return this.medicalNotesCategories.filter((item) => {
				return (
					item.medicalNoteCategoryName.toLowerCase().includes(searchTerm) ||
					item.medicalNoteCategoryDescription.toLowerCase().includes(searchTerm) ||
					item.officeName.toLowerCase().includes(searchTerm)
				);
			});
		},
		groupedNotes () {
			const statusText = {
				0: 'Inactive',
				1: 'Active',
				3: 'All',
			};
			const filteredItems = this.filteredNotes.filter((item) => {
				return (
					(this.appBarUserStatusVerifier === 1 && item.status === 1) ||
					(this.appBarUserStatusVerifier === 0 && item.status === 0) ||
					this.appBarUserStatusVerifier === 3
				);
			});
			const mappedItems = filteredItems.map((item) => ({
				...item,
				statusText: statusText[item.status] || 'Unknown',
			}));
			this.mappedItems = mappedItems;
			return mappedItems.reduce((groups, item) => {
				let group = groups.find((g) => g.officeName === item.officeName);
				if (!group) {
					group = { officeName: item.officeName, notes: [] };
					groups.push(group);
				}
				group.notes.push(item);
				return groups;
			}, []);
		},
	},
};
</script>
